import { render, staticRenderFns } from "./CardRow.vue?vue&type=template&id=dbbf70b2&scoped=true&"
import script from "./CardRow.vue?vue&type=script&lang=js&"
export * from "./CardRow.vue?vue&type=script&lang=js&"
import style0 from "./CardRow.vue?vue&type=style&index=0&id=dbbf70b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbf70b2",
  null
  
)

export default component.exports